import clsx from 'clsx'

import PersistentPlatformFileUpload from 'components/persistentPlatform/PersistentPlatformFileUpload'

import styles from './NewBanner.module.scss'
import Mural from '../../../assets/images/other/mural.png'
import { Button } from '../button/Button'
import { Flex } from '../flex/Flex'

interface Props {
  image: 'left' | 'right' | 'both' | 'none'
  buttonText: string
  buttonUrl: string
  title: string
  text: string
  additionalContent?: 'fileUpload' | 'image'
  imageUrl?: string
  imagePositionBottom?: true
  bannerPosition: 'left' | 'right' | 'center'
  onClick?: () => void
  className?: string
}

const NewBanner = ({
  image,
  buttonText,
  buttonUrl,
  title,
  text,
  additionalContent,
  imageUrl,
  imagePositionBottom,
  bannerPosition,
  onClick,
  className,
}: Props) => {
  return (
    <div
      className={clsx(
        styles.container,
        bannerPosition === 'left' ? 'rounded-l-[16px]' : bannerPosition === 'right' ? 'rounded-r-[16px]' : '',
        `mb-16 relative ${className}`,
      )}
    >
      {image === 'left' && (
        <svg
          className={clsx(imagePositionBottom ? '-bottom-[39px]' : '-top-10', 'absolute left-[-39.5px]')}
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M47.8752 47.8759C47.0067 59.2053 44.2803 70.0147 40.0001 80C35.7199 70.0147 32.9935 59.2053 32.125 47.8759C20.7952 47.0075 9.98552 44.2811 0 40.0008C9.98549 35.7205 20.7952 32.994 32.1248 32.1256C32.9932 20.7956 35.7197 9.98571 40.0001 0C44.2805 9.98572 47.0069 20.7956 47.8753 32.1256C59.2049 32.9941 70.0145 35.7205 80 40.0008C70.0145 44.2811 59.2049 47.0075 47.8752 47.8759Z"
            fill="#00504D"
          />
        </svg>
      )}
      {image === 'both' && (
        <svg
          className={clsx(imagePositionBottom ? '-bottom-[39px]' : '-top-10', 'absolute left-[-40.5px]')}
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M47.8752 47.8759C47.0067 59.2053 44.2803 70.0147 40.0001 80C35.7199 70.0147 32.9935 59.2053 32.125 47.8759C20.7952 47.0075 9.98552 44.2811 0 40.0008C9.98549 35.7205 20.7952 32.994 32.1248 32.1256C32.9932 20.7956 35.7197 9.98571 40.0001 0C44.2805 9.98572 47.0069 20.7956 47.8753 32.1256C59.2049 32.9941 70.0145 35.7205 80 40.0008C70.0145 44.2811 59.2049 47.0075 47.8752 47.8759Z"
            fill="#00504D"
          />
        </svg>
      )}
      <Flex direction="row" className="min-h-[248px] h-full">
        <Flex direction="column" justify="between" className={styles.textContainer}>
          <div>
            {title && <h3 className={clsx(styles.whiteXLHeading, 'max-w-[596px] mb-4')}>{title}</h3>}
            {text && <p className={clsx(styles.sBody, 'max-w-[596px] mb-6')}>{text}</p>}
          </div>
          <Button
            className={clsx(styles.button, additionalContent && 'mb-6')}
            text={buttonText}
            variant="primary"
            onClick={() => {
              window.open(buttonUrl, '_blank')
              onClick && onClick()
            }}
          />
          {additionalContent === 'fileUpload' && <PersistentPlatformFileUpload />}
          {additionalContent === 'image' && (
            <div className={styles.imageContainer}>
              {imageUrl ? <img className="w-full h-[146px]" src={Mural} alt="mural" /> : 'No Image URL Provided'}
            </div>
          )}
        </Flex>
      </Flex>
      {image === 'both' && (
        <svg
          className={clsx(imagePositionBottom ? '-bottom-[39px]' : '-top-10', 'absolute -right-[41.35px] z-1')}
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M47.8752 47.8759C47.0067 59.2053 44.2803 70.0147 40.0001 80C35.7199 70.0147 32.9935 59.2053 32.125 47.8759C20.7952 47.0075 9.98552 44.2811 0 40.0008C9.98549 35.7205 20.7952 32.994 32.1248 32.1256C32.9932 20.7956 35.7197 9.98571 40.0001 0C44.2805 9.98572 47.0069 20.7956 47.8753 32.1256C59.2049 32.9941 70.0145 35.7205 80 40.0008C70.0145 44.2811 59.2049 47.0075 47.8752 47.8759Z"
            fill="#00504D"
          />
        </svg>
      )}
      {image === 'right' && (
        <svg
          className={clsx(imagePositionBottom ? '-bottom-[39px]' : '-top-10', 'absolute -right-[40.35px]')}
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M47.8752 47.8759C47.0067 59.2053 44.2803 70.0147 40.0001 80C35.7199 70.0147 32.9935 59.2053 32.125 47.8759C20.7952 47.0075 9.98552 44.2811 0 40.0008C9.98549 35.7205 20.7952 32.994 32.1248 32.1256C32.9932 20.7956 35.7197 9.98571 40.0001 0C44.2805 9.98572 47.0069 20.7956 47.8753 32.1256C59.2049 32.9941 70.0145 35.7205 80 40.0008C70.0145 44.2811 59.2049 47.0075 47.8752 47.8759Z"
            fill="#00504D"
          />
        </svg>
      )}
    </div>
  )
}

export default NewBanner
